// theme/assets/fernova-animations.js
// Waits for Motion (Framer) to load from CDN, then wires up all animations.

(function () {
  'use strict';

  function init(Motion) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Respect reduced motion: expose no-op crossfade helpers and skip animations.
      window.fvCrossfadeImage = function (imgEl, newSrc) { if (imgEl) { imgEl.srcset = ''; imgEl.src = newSrc; } };
      window.fvCrossfadePanel = function (imgEl, newSrc, nameEl, newName, priceEl, newPrice) {
        if (nameEl) nameEl.textContent = newName;
        if (priceEl) priceEl.textContent = newPrice;
        if (imgEl) imgEl.src = newSrc;
      };
      return;
    }

    const { animate, stagger, inView } = Motion;

    // Hero entrance is a pure-CSS @keyframes animation (see fernova-landing.liquid)
    // so it never depends on the Motion CDN loading before the page's most
    // important content becomes visible.

    // ── SCROLL-VIEWER LIST STAGGER ──
    const listItems = document.querySelectorAll('.fv-scroll-viewer__item');
    if (listItems.length) {
      inView('.fv-scroll-viewer__list', () => {
        animate(
          listItems,
          { opacity: [0, 1], y: [16, 0] },
          { delay: stagger(0.08), duration: 0.5, easing: [0.25, 0.46, 0.45, 0.94] }
        );
      });
    }

    // ── COLLECTION GRID STAGGER ──
    const gridItems = document.querySelectorAll('.fv-product-card');
    if (gridItems.length) {
      inView('.fv-collection-grid', () => {
        animate(
          gridItems,
          { opacity: [0, 1], y: [20, 0] },
          { delay: stagger(0.06), duration: 0.45, easing: [0.25, 0.46, 0.45, 0.94] }
        );
      });
    }

    // ── QUICK ADD OVERLAY ──
    document.querySelectorAll('.fv-product-card').forEach(card => {
      const overlay = card.querySelector('.fv-product-card__overlay');
      if (!overlay) return;
      card.addEventListener('mouseenter', () => {
        animate(overlay, { opacity: [0, 1] }, { duration: 0.25 });
      });
      card.addEventListener('mouseleave', () => {
        animate(overlay, { opacity: [1, 0] }, { duration: 0.2 });
      });
    });

    // ── PDP IMAGE CROSSFADE ──
    // Called externally by fernova-pdp section JS on variant change.
    // Rapid swatch/thumb clicks can fire this multiple times before the first
    // crossfade settles. Animate opacity from its live value (not a hardcoded
    // [1,0]/[0,1] keyframe) and gate the src-swap with a generation token so
    // only the most recent call gets to set the final image + fade it back in.
    // Without this, an interrupted call can leave the image stuck at a
    // partial opacity.
    window.fvCrossfadeImage = function (imgEl, newSrc) {
      if (!imgEl) return;
      const gen = (imgEl._fvCrossfadeGen = (imgEl._fvCrossfadeGen || 0) + 1);
      const settle = () => {
        if (imgEl._fvCrossfadeGen !== gen) return; // superseded by a newer crossfade
        imgEl.srcset = '';
        imgEl.src = newSrc;
        animate(imgEl, { opacity: 1 }, { duration: 0.4, easing: [0.25, 0.46, 0.45, 0.94] });
      };
      const anim = animate(imgEl, { opacity: 0 }, { duration: 0.2 });
      const finished = anim.finished || anim;
      Promise.resolve(finished).then(settle, settle);
    };

    // ── SCROLL-VIEWER RIGHT PANEL CROSSFADE ──
    // Called by fernova-landing section JS when active product changes.
    // Name/price update synchronously; only the image fades.
    window.fvCrossfadePanel = function (imgEl, newSrc, nameEl, newName, priceEl, newPrice) {
      if (nameEl) nameEl.textContent = newName;
      if (priceEl) priceEl.textContent = newPrice;
      const anim = animate(imgEl, { opacity: [1, 0], scale: [1, 1.04] }, { duration: 0.15 });
      const finish = anim.finished || (anim.then ? anim : null);
      const swap = () => {
        imgEl.src = newSrc;
        animate(imgEl, { opacity: [0, 1], scale: [1.04, 1] }, { duration: 0.55, easing: [0.25, 0.46, 0.45, 0.94] });
      };
      if (finish && finish.then) {
        finish.then(swap);
      } else {
        setTimeout(swap, 150);
      }
    };

    // ── TEASER CARD PARALLAX ON SCROLL ──
    document.querySelectorAll('.fv-teaser-card__image').forEach(img => {
      inView(img.closest('.fv-teaser-card'), () => {
        animate(img, { scale: [1.08, 1] }, { duration: 0.9, easing: [0.25, 0.46, 0.45, 0.94] });
      });
    });
  }

  // Both scripts are defer'd — motion.js executes before this file by DOM order.
  if (window.Motion) {
    init(window.Motion);
  }
})();
